/**
 * 影音首页模块接口列表
 */
import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const VideoApi = {
  //登录接口
  Login(params) {
    let postParam = {
      iUser: params.iUser.replace(/\+/g, " "),
      userNameOrEmailAddress: params.iMail,
      uid: params.UID,
      password: ""
    };
    return axios.post(`${base.dev}/TokenAuth/Authenticate`, postParam);
  },
  // 首页接口（编辑精选，影片8条数据）
  VideoListDesk(params) {
    return axios.get(`${base.dev}/services/app/Moive/GetMoiveListDesk`, {
      params
    });
  },

  //根据影片类型Id获取影片列表
  GetMovieTypeListById(params) {
    return axios.get(`${base.dev}/services/app/Moive/GetPageMovieByTypeId`, {
      params: params
    });
  },
  //观看影片  根据影片id获取影片的信息，相关影片，集数
  async WatchingMovie(params) {
    return await axios.get(`${base.dev}/services/app/Moive/Get`, { params });
  },
  pageViews(params) {
    return axios.post(
      `${base.dev}/services/app/Moive/UpdateStatistics`,
      params
    );
  },
  //观看节目
  WatchingTv(params) {
    return axios.get(
      `${base.dev}/services/app/Program/GetPageProgramMovieById`,
      { params }
    );
  },

  //#region sonnet tv列表
  //soonet影片
  //添加影片
  AddMovie(params) {
    return axios.post(`${base.dev}/services/app/Moive/Create`, params);
  },
  editMovie(params) {
    return axios.put(`${base.dev}/services/app/Moive/Update`, params);
  },
  GetByMovieId(params) {
    return axios.get(`${base.dev}/services/app/Moive/Get`, { params });
  },
  delMovie(params) {
    return axios.delete(`${base.dev}/services/app/Moive/Delete`, {
      params: params
    });
  },
  //#endregion
  //#region 精选.
  GetExquisite(params) {
    return axios.get(`${base.dev}/services/app/Exquisite/GetExquisite`, {
      params
    });
  },
  AddExquisite(params) {
    return axios.post(`${base.dev}/services/app/Exquisite/Create`, params);
  },
  removeExquisite(params) {
    return axios.delete(`${base.dev}/services/app/Exquisite/RemoveExquiste`, {
      params: params
    });
  },
  updateexquiste(params) {
    return axios.put(`${base.dev}/services/app/Exquisite/Update`, params);
  },
  //#endregion
  //后台接口
  VideoList(params) {
    return axios.get(`${base.dev}/services/app/Moive/GetMoiveList`, { params });
  },

  //#region 节目列表

  //获取节目列表与节目类型列表(后台)
  GetProgramList(params) {
    return axios.get(`${base.dev}/services/app/Program/GetPageProgramOrType`, {
      params
    });
  },
  //前台
  GetPageProgramOrTypeDesk(params) {
    return axios.get(
      `${base.dev}/services/app/Program/GetPageProgramOrTypeDesk`,
      { params }
    );
  },

  //根据Id获取单个节目信息
  GetProgramSingle(params) {
    return axios.get(`${base.dev}/services/app/Program/Get`, { params });
  },
  //根据节目类型查询节目列表
  getProgramListByTypeId(params) {
    return axios.get(`${base.dev}/services/app/Program/GetProgramByTypeID`, {
      params
    });
  },
  //添加节目
  AddProgram(params) {
    return axios.post(`${base.dev}/services/app/Program/Create`, params);
  },
  //修改节目
  EditProgram(params) {
    return axios.put(`${base.dev}/services/app/Program/Update`, params);
  },
  //按浏览量排序
  OrderByBrowse(params) {
    return axios.get(`${base.dev}/services/app/Program/UpdateMovieViewStore`, {
      params
    });
  },
  DeleteProgram(params) {
    return axios.delete(`${base.dev}/services/app/Program/Delete`, {
      params: params
    });
  },
  //#endregion

  //#region 节目类型

  //新增
  addProgramType(params) {
    return axios.post(`${base.dev}/services/app/Program/Create`, params);
  },
  //修改
  editProgramType(params) {
    return axios.put(`${base.dev}/services/app/Program/Update`, params);
  },
  //根據id獲取節目類型
  GetSingleProgramType(params) {
    return axios.get(`${base.dev}/services/app/Program/Get`, { params });
  },
  //删除节目类型
  DeleteProgramType(params) {
    return axios.delete(`${base.dev}/services/app/Program/Delete`, {
      params: params
    });
  },
  SortProgram(params) {
    return axios.post(`${base.dev}/services/app/Program/UpdateStore`, params);
  },

  //#endregion

  //#region 影片類型
  //获取影片类型列表
  GetMovieTypeList(params) {
    return axios.get(`${base.dev}/services/app/MoveType/GetPageMoiveType`, {
      params: params
    });
  },
  //根据id获取影片类型
  GetSingleType(params) {
    return axios.get(`${base.dev}/services/app/MoveType/Get`, { params });
  },
  //修改影片類型
  EditVideo(params) {
    return axios.put(`${base.dev}/services/app/MoveType/Update`, params);
  },
  //添加影片类型
  AddVideo(params) {
    return axios.post(`${base.dev}/services/app/MoveType/Create`, params);
  },
  //删除影片类型
  DeleteVideoType(params) {
    return axios.delete(`${base.dev}/services/app/MoveType/Delete`, {
      params: params
    });
  },
  //排序
  Sort(params) {
    return axios.post(`${base.dev}/services/app/MoveType/UpdateStore`, params);
  },
  //#endregion

  //#region   影片社區模塊
  GetMoiveCommunityAll(params) {},
  //#endregion

  //#region 后台接口

  //获取节目列表与节目类型列表(后台)

  //#region 节目
  GetAdminProgramList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminProgram/GetPageProgramOrType`,
      { params }
    );
  },
  //根据Id获取单个节目信息
  GetAdminProgramSingle(params) {
    return axios.get(`${base.dev}/services/app/AdminProgram/Get`, { params });
  },
  //根据节目类型查询节目列表
  getAdminProgramListByTypeId(params) {
    return axios.get(
      `${base.dev}/services/app/AdminProgram/GetProgramByTypeID`,
      { params }
    );
  },
  //添加节目
  AddAdminProgram(params) {
    return axios.post(`${base.dev}/services/app/AdminProgram/Create`, params);
  },
  //修改节目
  EditAdminProgram(params) {
    return axios.put(`${base.dev}/services/app/AdminProgram/Update`, params);
  },
  //按浏览量排序
  OrderByAdminBrowse(params) {
    return axios.get(
      `${base.dev}/services/app/AdminProgram/UpdateMovieViewStore`,
      { params }
    );
  },
  DeleteAdminProgram(params) {
    return axios.delete(`${base.dev}/services/app/AdminProgram/Delete`, {
      params: params
    });
  },
  //排序
  SortAdminProgram(params) {
    return axios.post(
      `${base.dev}/services/app/AdminProgram/UpdateStore`,
      params
    );
  },
  //#endregion
  //#region 节目类型
  //新增
  addAdminProgramType(params) {
    return axios.post(`${base.dev}/services/app/AdminProgram/Create`, params);
  },
  //修改
  editAdminProgramType(params) {
    return axios.put(`${base.dev}/services/app/AdminProgram/Update`, params);
  },
  //根據id獲取節目類型
  GetAdminSingleProgramType(params) {
    return axios.get(`${base.dev}/services/app/AdminProgram/Get`, { params });
  },
  //删除节目类型
  DeleteAdminProgramType(params) {
    return axios.delete(`${base.dev}/services/app/AdminProgram/Delete`, {
      params: params
    });
  },
  //#endregion
  //#region 影片
  //获取影片列表
  AdminVideoList(params) {
    return axios.get(`${base.dev}/services/app/AdminMoive/GetMoiveList`, {
      params
    });
  },
  //添加影片
  AdminAddMovie(params) {
    return axios.post(`${base.dev}/services/app/AdminMoive/Create`, params);
  },
  //根据id获取影片信息
  async AdminMoiveGet(params) {
    return await axios.get(`${base.dev}/services/app/AdminMoive/Get`, {
      params
    });
  },
  //根据id获取影片信息
  async PushMoiveLivegoCopyConsumer(params) {
    return await axios.post(
      `${base.upload}/services/app/AdminMoive/PushMoiveLivegoCopyConsumer`,
      params
    );
  },
  //编辑影片
  AdmineditMovie(params) {
    return axios.put(`${base.dev}/services/app/AdminMoive/Update`, params);
  },
  //删除影片
  AdmindelMovie(params) {
    return axios.delete(`${base.dev}/services/app/AdminMoive/Delete`, {
      params: params
    });
  },

  //#endregion

  //#region 影片类型

  //获取影片类型列表
  GetAdminMovieTypeList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminMoveType/GetPageMoiveType`,
      {
        params: params
      }
    );
  },
  //根据id获取影片类型
  GetAdminSingleType(params) {
    return axios.get(`${base.dev}/services/app/AdminMoveType/Get`, { params });
  },
  //修改影片類型
  EditAdminVideo(params) {
    return axios.put(`${base.dev}/services/app/AdminMoveType/Update`, params);
  },
  //添加影片类型
  AddAdminVideo(params) {
    return axios.post(`${base.dev}/services/app/AdminMoveType/Create`, params);
  },
  //删除影片类型
  DeleteAdminVideoType(params) {
    return axios.delete(`${base.dev}/services/app/AdminMoveType/Delete`, {
      params: params
    });
  },
  //排序
  AdminSort(params) {
    return axios.post(
      `${base.dev}/services/app/AdminMoveType/UpdateStore`,
      params
    );
  },

  //#endregion

  /**
   * @description : 置顶热门关键词
   * @param name {String}
   * @date : 2023-07-17 12:57:12
   */
  UpdateTop(params) {
    return axios.post(
      `${base.dev}/services/app/AdminExquisite/UpdateTop`,
      params
    );
  },
  /**
   * @description : 新增关键词
   * @param name {String}
   * @date : 2023-07-17 12:57:00
   */
  InsertSearchResponse(params) {
    return axios.post(
      `${base.dev}/services/app/AdminExquisite/InsertSearchResponse`,
      params
    );
  },
  /**
   * @description : 获取搜索列表
   * @param name {String}
   * @date : 2023-07-17 12:56:47
   */
  GetSearchResponseList(params) {
    return axios.get(
      `${base.dev}/services/app/AdminExquisite/getSearchResponseList`,
      { params }
    );
  },
  /**
   * @description : 刪除熱詞
   * @param name {String}
   * @date : 2023-07-18 10:10:29
   */
  DeleteSearchResponse(params) {
    return axios.get(
      `${base.dev}/services/app/AdminExquisite/DeleteSearchResponse`,
      { params }
    );
  },

  HomeGetSearchResponseList(params) {
    return axios.get(`${base.url}/Home/getSearchResponseList`, { params });
  },
  //#region 精选
  //精选列表
  GetAdminExquisite(params) {
    return axios.get(`${base.dev}/services/app/AdminExquisite/GetExquisite`, {
      params
    });
  },
  //添加精选
  AddAdminExquisite(params) {
    return axios.post(`${base.dev}/services/app/AdminExquisite/Create`, params);
  },
  //删除精选
  removeAdminExquisite(params) {
    return axios.delete(
      `${base.dev}/services/app/AdminExquisite/RemoveExquiste`,
      { params: params }
    );
  },
  //修改精选
  updateAdminexquiste(params) {
    return axios.put(`${base.dev}/services/app/AdminExquisite/Update`, params);
  },
  //#endregion
  //#region 分片上传视频

  //分片上传
  uploadfileGather(params) {
    return axios.get(`${base.upload}/TokenAuth/UploadTempHe`, { params });
  },
  //查重
  CheckFileUpload(params) {
    return axios.get(`${base.upload}/TokenAuth/UploadTempCheck`, { params });
  },

  //分片上传
  uploadfileGather2(params) {
    return axios.get(`${base.dev}/TokenAuth/UploadTempHe`, { params });
  },
  //查重
  CheckFileUpload2(params) {
    return axios.get(`${base.dev}/TokenAuth/UploadTempCheck`, { params });
  },
  //#endregion

  //#endregion
  //#region 用户主页
  //获取用户收藏的影片
  getFavoriteByUserId(params) {
    return axios.get(`${base.dev}/services/app/Moive/getFavoriteByUserId`, {
      params
    });
  },
  //获取用户发布的视频
  getVideoPublish(params) {
    return axios.get(`${base.dev}/services/app/Moive/GetMoiveByUserList`, {
      params
    });
  },
  //获取用户发布的影片和视频数量
  getVideoAndMovieCount(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetPhotoReleaseCount`,
      { params }
    );
  },
  DeletePhoto(params) {
    return axios.delete(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/Delete`,
      { params: params }
    );
  },
  delvideo(params) {
    return axios.delete(`${base.dev}/services/app/Moive/Delete`, {
      params: params
    });
  },
  //#endregion
  getVideoAndMovieCountByUser(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetPhotoReleaseCountByUser`,
      { params }
    );
  },
  GetViewList(params) {
    return axios.get(`${base.dev}/services/app/ViewingRecords/GetViewList`, {
      params
    });
  },
  ViewingRecordsDel(params) {
    return axios.delete(`${base.dev}/services/app/ViewingRecords/Delete`, {
      params
    });
  },
  ViewingRecordsDelAll(params) {
    return axios.delete(`${base.dev}/services/app/ViewingRecords/DeleteAll`, {
      params
    });
  },
  SubscribeGetAll(params) {
    return axios.get(`${base.dev}/services/app/Subscribe/GetAllSubscribe`, {
      params
    });
  },
  SubscribeGet(params) {
    return axios.get(`${base.dev}/services/app/Subscribe/Get`, {
      params
    });
  },
  GetRecommendSubLst(params) {
    return axios.post(`${base.dev}/services/app/Subscribe/GetRecommendSubLst`, 
      params
    );
  }
};

export default VideoApi


// WEBPACK FOOTER //
// ./src/api/Video/VideoApi.js